import React, { useState } from 'react';
import Sheet from '../ui/Sheet';
import AvatarSelector from '../ui/AvatarSelector';

// Shown once, before the spotlight tour, to a genuinely-new student — lets them pick their Zaptude identity early.
// `onDone` receives the chosen avatarId (or null if skipped) and is responsible for persisting it
// (PATCH /api/portal/avatar) — this component only handles the picking UI, never talks to the API.
// A bottom sheet: focus is trapped while open, Esc / backdrop = skip.
const AvatarIntro = ({ name, onDone }) => {
  const [selected, setSelected] = useState(null);
  return (
    <Sheet
      open
      onClose={() => onDone(null)}
      title={`Welcome to Zaptude, ${(name || '').split(' ')[0]}.`}
      size="lg"
      hideClose
      footer={(
        <>
          <button type="button" className="z-btn z-btn--ghost" onClick={() => onDone(null)}>Skip for now</button>
          <button type="button" className="z-btn z-btn--primary" disabled={!selected} onClick={() => onDone(selected)}>Continue</button>
        </>
      )}
    >
      <p className="z-help" style={{ margin: '0 0 var(--z-space-4)', fontSize: 'var(--z-fs-md)' }}>Pick an avatar — this is your identity as you level up.</p>
      <AvatarSelector selectedId={selected} onSelect={setSelected} name={name} />
    </Sheet>
  );
};

export default AvatarIntro;
